import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{attrs:{"label":"Bill Rate Type","items":_vm.billRateTypesList,"item-text":"billRateType","item-value":"id","rules":[_vm.requiredCheck()],"readonly":_vm.readonly,"disabled":_vm.disabled,"clearable":_vm.clearable ? _vm.clearable : false,"outlined":"","dense":_vm.dense ? _vm.dense : false},model:{value:(_vm.billRateTypeValue),callback:function ($$v) {_vm.billRateTypeValue=$$v},expression:"billRateTypeValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }